module.exports = __webpack_public_path__ + "img/logo.d52764c2.png";